import { gql } from "@apollo/client";

export const GET_ADMIN_INDICACION_DETALLE_PROF = gql`
    query GetAdminIndicacionesProf($idIndicacionAprobacion: Int!) {
    adminIndicacionDetalleProf(idIndicacionAprobacion: $idIndicacionAprobacion) {
      success,
      error,
      valorEsperado {
        tipo,
        total
      }
    }
  }
`;